/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { FC, RefAttributes } from 'react';
import {
	createLayout,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { componentWithFG } from '@jira/platform__utils-feature-gates-gate-component/src/index.tsx';
import { lazyAfterPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const AsyncTransitionHomeRenderer: LazyComponent<() => React.JSX.Element> = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-eoc-changeboarding-layout-transition-home-renderer" */ '@jira/eoc__changeboarding/src/ui/transition-home/main.tsx'
		).then((module) => module.TransitionHomeRenderer),
	{ ssr: false },
);
AsyncTransitionHomeRenderer.displayName = 'AsyncTransitionHomeRenderer';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const AsyncWelcomeModalRenderer: LazyComponent<() => React.JSX.Element> = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-eoc-changeboarding-layout-welcome-modal-renderer" */ '@jira/eoc__changeboarding/src/ui/wizard/main.tsx'
		).then((module) => module.WelcomeModalRenderer),
	{ ssr: false },
);
AsyncWelcomeModalRenderer.displayName = 'AsyncWelcomeModalRenderer';

export const MigrationHubRightSidebar: FC<RefAttributes<unknown>> = componentWithFG(
	'operations-migration-hub-jira',
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyAfterPaint(
		() =>
			import(
				/* webpackChunkName: "async-ops-migration-hub-right-sidebars" */ '@jira/platform__layouts-ops-settings-layout/src/ui/right-sidebars/index.tsx'
			),
		{ ssr: false },
	),
	() => null,
);
MigrationHubRightSidebar.displayName = 'MigrationHubRightSidebar';

export const MigrationHubOnboarding: FC<RefAttributes<unknown>> = componentWithFG(
	'operations-migration-hub-jira',
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyAfterPaint(
		() =>
			import(
				/* webpackChunkName: "async-ops-migration-hub-onboarding" */ '@jira/platform__layouts-ops-settings-layout/src/ui/onboarding/index.tsx'
			),
		{ ssr: false },
	),
	() => null,
);
MigrationHubOnboarding.displayName = 'MigrationHubOnboarding';

export const eocChangeboardingLayout: Layout = createLayout({
	get globalComponents() {
		return [AsyncTransitionHomeRenderer, AsyncWelcomeModalRenderer, MigrationHubOnboarding];
	},
	rightSidebars: [MigrationHubRightSidebar],
});
